module.exports = __webpack_public_path__ + "img/table.e36f3264.png";